import { useContext } from "react";

import ApiClientContext from "../context/ApiClientContext";

const useApiClient = () => useContext(ApiClientContext);

export default useApiClient;
